import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Modal } from "@gemini/ui";
import { useKeyboardNav } from "@/hooks";
import { Masonry } from "@/gallery/components";
import { useI18n } from "@/contexts/i18n";
import { ModalTopBar } from "@/components/UI";
import { CTAs } from "@/components/CTAs";
import { useGalleryContext } from "@/gallery/contexts";
import { StickyCta } from "@/components/contacting";
export const MasonryModal = ({ isOpen, testId }) => {
    const { t } = useI18n();
    const { openSliderModal, closeMasonryModal, toggleMasonryModal, updateInitialStepIndex, } = useGalleryContext();
    const openOnSlideIndex = (index) => {
        updateInitialStepIndex(index);
        openSliderModal();
    };
    useKeyboardNav({
        handleEscape: closeMasonryModal,
    });
    return (_jsx(Modal, { displayMode: "fullscreen", hasContentPadding: false, hasCloseButton: false, isOpen: isOpen, trigger: () => null, onOpenChange: toggleMasonryModal, testId: `${testId}`, isKeyboardDismissDisabled: true, children: _jsxs(Box, { backgroundColor: "color.border.constant.white", position: "relative", display: "flex", flexDirection: "column", alignItems: "center", children: [_jsx(ModalTopBar, { testId: `${testId}.TopBar`, closeAction: closeMasonryModal, buttonLabel: t("gallery.modal.back.cta"), additionalCTAs: _jsx(CTAs, {}), showContacting: true, showTabs: false, tracking: {
                        avZone: "masonry",
                    } }), _jsx(Masonry, { openOnSlideIndex: openOnSlideIndex, testId: `${testId}.Masonry` }), _jsx(StickyCta, { tracking: { avZone: "masonry" } })] }) }));
};
